import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_COURSES_QUERY } from "./consts";
import queryCoursesReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_COURSES_QUERY, builder => {
  builder.register(PATH_TO_COURSES_QUERY, queryCoursesReducer);
});

//actions
export { receiveQueryResults } from "./actions";
export { fetchQueryCoursesActionFactory } from "./actions/meta";

//selectors
export {
  getCountByTagId,
  getCourses,
  getCourse,
  getCourseTagIds,
  getAllCourseIds,
  getCourseName,
  getCourseAuthors,
  getCourseReferences,
  getCourseHeaderImageURL,
  getCourseSubscriptionTier,
  getCourseExamQuestionsCount,
  doesCourseHaveExamQuestions,
  courseIsPremium,
  courseExists,
  tagHasNoResults,
  getAggregations
} from "./selectors";

export {
  getFetchCoursesQueryStarted,
  getFetchCoursesQuerySuccess,
  getFetchCoursesQueryError,
  getFetchCoursesQueryLastFetched,
  coursesQueryHasFinishedFetching,
  coursesQueryNeedsFetching
} from "./selectors/meta";
